import React, {useContext, useEffect} from 'react';
import PropTypes from 'prop-types';

import myHealthFirst from 'bookings/my_health_first.js';
import {ButtonV2} from '@HealthShareAU/hs-component-library';

import {
    BOOK_NOW_BTN_MH1,
    BOOK_NOW_BTN_MH1_PRIMARY,
    BOOK_NOW_BTN_MH1_PRIMARY_DISABLED,
    GA_ID,
} from 'core/constants.js';
import {BookingButton} from '@HealthShareAU/hs-component-library';

const MH1BookNowBtn = ({
    bookingIntegration,
    colorTheme,
    gaSelector,
    gaObjectType,
    availability,
    isMh1Running,
    dataSource,
}) => {
    useEffect(() => {
        let timeout;

        function setupWidget() {
            myHealthFirst.widgetSetup();
        }

        function safeGtag() {
            try {
                const dl = window.dataLayer;

                if (Array.isArray(dl) && typeof dl.push === 'function') {
                    dl.push(arguments);
                    return true;
                }

                return false;
            } catch (e) {
                return false;
            }
        }

        function init() {
            if (window.__GA_IDS_LOADED__) {
                setupWidget();
                return;
            }

            window.__GA_IDS_LOADED__ = true;
            window.__GA_CLIENT_ID__ = null;
            window.__GA_SESSION_ID__ = null;

            let finished = false;

            function done(clientId, sessionId) {
                if (finished) return;
                finished = true;

                window.__GA_CLIENT_ID__ = clientId || null;
                window.__GA_SESSION_ID__ = sessionId || null;

                setupWidget();
            }

            timeout = setTimeout(() => {
                done(null, null);
            }, 2000);

            try {
                const ok = safeGtag('get', GA_ID, 'client_id', function (
                    clientId,
                ) {
                    safeGtag('get', GA_ID, 'session_id', function (sessionId) {
                        clearTimeout(timeout);
                        done(clientId, sessionId);
                    });
                });

                if (!ok) {
                    clearTimeout(timeout);
                    done(null, null);
                }
            } catch (e) {
                clearTimeout(timeout);
                done(null, null);
            }
        }

        init();

        return () => {
            if (timeout) {
                clearTimeout(timeout);
            }
        };
    }, [isMh1Running]);

    // Banner Ads can provide booking data via `availability` alone (no
    // bookingIntegration on the payload). Fall back to availability.id so the
    // button still renders in that case.
    const bookingId = bookingIntegration?.bookingId ?? availability?.id;
    if (bookingId == null) {
        return null;
    }

    return isMh1Running ? (
        <div className="mh1-book-now-button">
            <BookingButton
                availability={availability}
                customClass="1stAvailableWidget2"
                colorTheme={colorTheme}
                id={bookingId}
                dataSource={dataSource?.source}
                dataTestId={BOOK_NOW_BTN_MH1}
                gaSelector={
                    gaSelector || availability
                        ? BOOK_NOW_BTN_MH1_PRIMARY
                        : BOOK_NOW_BTN_MH1_PRIMARY_DISABLED
                }
                gaObjectType={gaObjectType}
                icon="calendarCheck"
                text="Book now"
            />
        </div>
    ) : (
        <ButtonV2
            customClass="1stAvailableWidget2"
            colorTheme={colorTheme}
            id={bookingId}
            dataSource={dataSource?.source}
            dataTestId={BOOK_NOW_BTN_MH1}
            gaSelector={gaSelector || BOOK_NOW_BTN_MH1_PRIMARY}
            gaObjectType={gaObjectType}
            icon="calendarCheck"
            text="Book now"
        />
    );
};

MH1BookNowBtn.propTypes = {
    bookingIntegration: PropTypes.shape({
        bookingId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
            .isRequired,
        name: PropTypes.string.isRequired,
        url: PropTypes.string,
    }),
    colorTheme: PropTypes.object,
    gaSelector: PropTypes.string,
    gaObjectType: PropTypes.string,
    availability: PropTypes.shape({
        id: PropTypes.string.isRequired,
        next_available: PropTypes.string.isRequired,
    }),
};
export default MH1BookNowBtn;
